import { cln } from '../../lib/utils';
import { RichTextMenuOption } from '../../types';

export function MenuButton({ icon, className, ...props }: RichTextMenuOption) {
  return (
    <button {...props} type="button" className={cln('p-2 font-normal', className)}>
      <i className={cln('text leading-4', icon)} />
    </button>
  );
}
